<template>
  <el-select :value="value" @change="change" filterable remote :remote-method="search" :disabled="disabled">
    <el-option v-for="item in companyList" :key="item.id" :label="item.abbreviation" :value="item.id"></el-option>
  </el-select>
</template>

<script>
export default {
  props: {
    value: Number,
    disabled: Boolean
  },
  data () {
    return {
      companyList: []
    }
  },
  watch: {
    'value' (val) {
      if (val > 0 && this.companyList.length === 0) {
        this.$http.get('/dbapi/company_list?id=' + val).then(data => {
          this.companyList = data.list
        })
      }
    }
  },
  mounted () {
    if (this.value > 0) {
      this.$http.get('/dbapi/company_list?id=' + this.value).then(data => {
        this.companyList = data.list
      })
    }
  },
  methods: {
    change (v) {
      this.$emit('input', v)
      let companys = this.companyList.filter(r => r.id === v)
      if (companys.length > 0) {
        this.$emit('change', companys[0])
      }
    },
    search (query) {
      this.$http.get('/dbapi/company_list', {
        params: {
          query: query + '%'
        }
      }).then(data => {
        this.companyList = data.list
      })
    }
  }
}
</script>